// Velo API Reference: https://www.wix.com/velo/reference/api-overview/introduction

$w.onReady(function () {

	// Write your Javascript code here using the Velo framework API

	// Print hello world:
	// console.log("Hello world!");

	// Call functions on page elements, e.g.:
	// $w("#button1").label = "Click me!";

	// Click "Run", or Preview your site, to execute your code

});

$w('#button5').onClick(function () {
	$w("#fullWidthSlides1").changeSlide(0)
})
$w('#button6').onClick(function () {
	$w("#fullWidthSlides1").changeSlide(1)
})
$w('#button7').onClick(function () {
	$w("#fullWidthSlides1").changeSlide(2)
})
$w('#button8').onClick(function () {
	$w("#fullWidthSlides1").changeSlide(3)
})